import * as endpoints from "../../api/endpoints"
import React, { Component } from "react"
import ReactDOM from "react-dom"
import { UserProfile } from "../../hooks/userProfile"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import Spinner from "../../booking/components/spinner"
import { isValidPhoneNumber } from "react-phone-number-input"

const emailValidatingRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default class FlightSignup {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.state = {
      email: "",
      flightId: elem.dataset.flightid,
      valid: true,
    }
    this.init()
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(
      <UserProfile>
        {(profile) => {
          if (profile) {
            return <FlightSignupComponent {...this.elem.dataset} profile={profile} />
          } else {
            return <FlightSignupComponent {...this.elem.dataset} profile={null} />
          }
        }}
      </UserProfile>,
      this.elem,
    )
  }
}

class FlightSignupComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      phoneNumber: "",
      flightId: props.flightid,
      acceptedTerms: false,
      validEmail: true,
      validPhoneNumber: true,
      validAcceptedTerms: true,
      profile: props.profile,
      ajaxSpinnerActive: false,
      ajaxSpinnerTransparent: false,
    }
  }

  getDerivedStateFromProps(nextProps, _prevState) {
    if (nextProps.profile) {
      let newState = {}

      if (nextProps.profile.EmailAddress) {
        newState.email = nextProps.profile.EmailAddress
      }
      if (nextProps.profile.ContactDetails && nextProps.profile.ContactDetails.MobilePhone) {
        newState.phoneNumber = nextProps.profile.ContactDetails.MobilePhone
      }
      if (nextProps.profile.ContactDetails && nextProps.profile.ContactDetails.NewsletterSubscription) {
        newState.acceptedTerms = true
      }

      return newState
    }

    // Return null if no changes to state
    return null
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.onEmailSubmit(e)
    this.onSmsSubmit(e)
  }

  onEmailSubmit = (e) => {
    e.preventDefault()
    let failedValidation = false
    if (!this.validateEmail(this.state.email)) {
      this.setState({ validEmail: false })
      failedValidation = true
    } else {
      this.setState({ validEmail: true })
    }
    if (!this.state.acceptedTerms) {
      this.setState({ validAcceptedTerms: false })
      failedValidation = true
    } else {
      this.setState({ validAcceptedTerms: true })
    }
    if (failedValidation) {
      return false
    }
    this.setState({ ajaxSpinnerActive: true })
    endpoints
      .subscribeToFlightByEmail(this.state.flightId, this.state.email)
      .then((_res) => {
        Emitter.emit("*", {
          type: emits.REQUEST_CONTENT_MODAL_OPEN,
          modalJson: {
            usePortalStyling: true,
            h3: this.props.successHeadline || "Success",
            richText: this.props.successMessage || "Du bliver nu informeret om ændringer på denne flyvning",
          },
        })
      })
      .catch((error) => {
        Emitter.emit("*", {
          type: emits.REQUEST_CONTENT_MODAL_OPEN,
          modalJson: {
            usePortalStyling: true,
            h3: error,
            richText: "",
          },
        })
      })
      .finally(() => {
        this.setState({ ajaxSpinnerActive: false })
      })
  }

  onSmsSubmit = (e) => {
    e.preventDefault()
    let failedValidation = false
    if (!this.validatePhoneNumber(this.state.phoneNumber)) {
      this.setState({ validPhoneNumber: false })
      failedValidation = true
    } else {
      this.setState({ validPhoneNumber: true })
    }
    if (!this.state.acceptedTerms) {
      this.setState({ validAcceptedTerms: false })
      failedValidation = true
    } else {
      this.setState({ validAcceptedTerms: true })
    }
    if (failedValidation) {
      return false
    }
    this.setState({ ajaxSpinnerActive: true })
    endpoints
      .subscribeToFlightBySms(this.state.flightId, this.state.phoneNumber)
      .then((_res) => {
        Emitter.emit("*", {
          type: emits.REQUEST_CONTENT_MODAL_OPEN,
          modalJson: {
            usePortalStyling: true,
            h3: this.props.successHeadline || "Success",
            richText: this.props.successMessage || "Du bliver nu informeret om ændringer på denne flyvning",
          },
        })
      })
      .catch((error) => {
        Emitter.emit("*", {
          type: emits.REQUEST_CONTENT_MODAL_OPEN,
          modalJson: {
            usePortalStyling: true,
            h3: error,
            richText: "",
          },
        })
      })
      .finally(() => {
        this.setState({ ajaxSpinnerActive: false })
      })
  }

  handleEmailClick = (e) => {
    this.onEmailSubmit(e)
    // document.querySelector('.js-module-flight-signup').querySelector('.js-email-form').dispatchEvent(new Event('submit'))
  }

  handleSmsClick = (e) => {
    this.onSmsSubmit(e)
    // document.querySelector('.js-module-flight-signup').querySelector('.js-sms-form').dispatchEvent(new Event('submit'))
  }

  validateEmail = (email) => {
    return emailValidatingRegex.test(String(email).toLowerCase())
  }

  validatePhoneNumber = (phoneNumber) => {
    return isValidPhoneNumber(phoneNumber)
  }

  createMarkup = (html) => {
    return { __html: html }
  }

  render() {
    let emailInput = (
      <div className="grid-item col--12 col-xs--9 form__section__inner">
        <div className="form__field form__field--text form__field--text--no-label is-bound is-required">
          <span className="form__valid"></span>
          <input
            className="form__item signup-email"
            name="email"
            type="email"
            placeholder={this.props.placeholderMail || "email adress"}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
          <span className={(this.state.validEmail ? "d-none" : "") + " form__notice form__notice--box is-invalid"}>
            {this.props.emailvalidationerror}
          </span>
        </div>
      </div>
    )
    let smsInput = (
      <div className="grid-item col--12 col-xs--9 form__section__inner">
        <div className="form__field form__field--text form__field--text--no-label is-bound is-required">
          <span className="form__valid"></span>
          <input
            className="form__item signup-email"
            name="phoneNumber"
            type="tel"
            placeholder={this.props.placeholderSms || "Phone number"}
            onChange={(e) => this.setState({ phoneNumber: e.target.value })}
            defaultValue={this.props.profile && this.props.profile.ContactDetails && this.props.profile.ContactDetails.MobilePhone}
          />
          <span className={(this.state.validPhoneNumber ? "d-none" : "") + " form__notice form__notice--box is-invalid"}>
            {this.props.smsvalidationerror || "Error in phone number use full number"}
          </span>
        </div>
      </div>
    )
    let permissionInput = (
      <div className="form__section form__section--short">
        <div className="form__field form__field--checkbox is-bound is-required">
          <label className="form__label">
            <input
              className="form__item signup-checkbox "
              name="check-name"
              type="checkbox"
              onChange={(e) => this.setState({ acceptedTerms: e.target.checked })}
            />
            <span className="form__label__text">
              <p dangerouslySetInnerHTML={this.createMarkup(this.props.terms)}></p>
            </span>
          </label>
        </div>
        <span className={(this.state.validAcceptedTerms ? "d-none" : "") + " form__notice form__notice--box is-invalid"}>
          {this.props.accepttermserror}
        </span>
      </div>
    )
    let emailSubmitClass = "grid-item col--12 col-xs--3"
    let smsSubmitClass = "grid-item col--12 col-xs--3"
    if (this.props.profile) {
      if (this.props.profile.EmailAddress) {
        emailInput = null
        emailSubmitClass = "grid-item col--12 col-xs--12"
      }
      if (this.props.profile.ContactDetails && this.props.profile.ContactDetails.MobilePhone) {
        // validate phone number
        if (this.validatePhoneNumber(this.props.profile.ContactDetails.MobilePhone)) {
          smsInput = null
          smsSubmitClass = "grid-item col--12 col-xs--12"
        }
      }
      if (this.props.profile.ContactDetails && this.props.profile.ContactDetails.NewsletterSubscription) {
        permissionInput = null
      }
    }

    const emailIsDisabled = this.props.isEmailDisabled && this.props.isEmailDisabled.toLowerCase() === "true"
    const smsIsDisabled = this.props.isSmsDisabled && this.props.isSmsDisabled.toLowerCase() === "true"

    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        <div className="w--wider newsletter-signup__inner">
          <div className="grid">
            <div className="grid-item col--12 col-lg--6">
              <h3>{this.props.header}</h3>
            </div>
            <form className="grid-item col--12 col-lg--6 form" onSubmit={this.onSubmit}>
              <input className="signup-flight-id" value={this.state.flightId} readOnly hidden />
              {emailIsDisabled ? null : (
                <div className="grid form__section form__section--short">
                  {emailInput}
                  <div className={emailSubmitClass}>
                    <a className="button button--medium button--general-inverted" onClick={this.handleEmailClick}>
                      <span className="text">{this.props.followMail || "Follow on email"}</span>
                    </a>
                  </div>
                  <div className="grid-item d-none d-block--md col-md--2 d-none--lg"></div>
                </div>
              )}
              {smsIsDisabled ? null : (
                <div className="grid form__section form__section--short">
                  {smsInput}
                  <div className={smsSubmitClass}>
                    <a className="button button--medium button--general-inverted" onClick={this.handleSmsClick}>
                      <span className="text">{this.props.followSms || "Follow on SMS"}</span>
                    </a>
                  </div>
                  <div className="grid-item d-none d-block--md col-md--2 d-none--lg"></div>
                </div>
              )}
              {permissionInput}
              <input type="submit" hidden />
            </form>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
